import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import emblaCarouselSchema from './schema';
import View from './View';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;

  // Early return if block is undefined
  if (!block) {
    return <div>EmblaCarousel: Missing block ID</div>;
  }

  // Generate the schema with proper props
  const schema = emblaCarouselSchema({
    ...props,
    formData: data,
  });

  const handleFieldChange = (id, value) => {
    if (id === 'slides') {
      const fixed = Array.isArray(value)
        ? value.map((slide) => ({
            ...slide,
            link: Array.isArray(slide.link) ? slide.link[0] : slide.link,
          }))
        : [];
      onChangeBlock(block, { ...data, slides: fixed });
    } else {
      onChangeBlock(block, { ...data, [id]: value });
    }
  };

  // Prepare form data for the sidebar
  const formData = {
    ...data,
    slides: Array.isArray(data.slides)
      ? data.slides.map((slide) => ({
          ...slide,
          link: Array.isArray(slide.link)
            ? slide.link
            : slide.link
              ? [slide.link]
              : [],
        }))
      : [],
  };

  return (
    <>
      <View data={data} id={block} />

      {selected && (
        <SidebarPortal selected={selected}>
          <BlockDataForm
            key={`listing-${data.useListing ? 'on' : 'off'}`}
            schema={schema}
            title="Embla Carousel"
            onChangeField={handleFieldChange}
            onChangeBlock={onChangeBlock}
            block={block}
            formData={formData}
          />
        </SidebarPortal>
      )}
    </>
  );
};

export default Edit;
